import { NavLink, useParams,useLocation } from "react-router";
import MetasItemComponent from "../../components/Metas/MetasItem";
import { useMetasByIdQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";
import type { LocationState } from "../../types/QueryParameters";
function MetasItem(){
    
    const params = useParams();
    const { data:meta, error, isLoading } = useMetasByIdQuery(params.id??"0");
    const location = useLocation();
    const state = location.state as LocationState | undefined;
    
    const {translate}=useTrads();
    
    return (
        error ? (
            <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>
        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
        ) : meta ? (
            <div>
                <nav>
                    <NavLink to={`/metas/${meta.id.toString()}/edit`}>{translate('btn_edit')}</NavLink>
                </nav>
                {state?.modified && <p className="p-3 mb-2 bg-success text-white">{translate('msg_meta_update')}</p>}
                <MetasItemComponent meta={meta}  />
            </div>
        ):null
    );
}
export default MetasItem;